import styled from 'styled-components';

import {Price as BasePrice, TextInput as BaseTextInput} from '@edna/components';
import {H1, H3} from '@edna/components/primitives';
import {mixins} from '@edna/components/styles';

import {Badge as BaseBadge} from 'src/components';
import {SecondaryText as BaseSecondaryText} from 'src/components/primitives';

export const Section = styled.section<{noMargin?: boolean}>`
  width: 100%;
  margin-bottom: ${({theme}) => theme.spacing.s5};
`;

export const Title = styled(H1)`
  margin-bottom: ${({theme}) => theme.spacing.s4};
`;

export const Subtitle = styled(H3)`
  margin-bottom: ${({theme}) => theme.spacing.s2};
`;

export const ManagerName = styled.div`
  ${mixins.flexAlign('normal', 'center')}
  ${mixins.f4}
  margin-top: ${({theme}) => theme.spacing.s1};
`;

export const Badge = styled(BaseBadge)`
  margin-top: ${({theme}) => theme.spacing.s2};
`;

export const TextInput = styled(BaseTextInput)`
  width: 100%;
  margin-top: ${({theme}) => theme.spacing.s2};
`;

export const Details = styled.div`
  ${mixins.flexAlign('initial', 'center')}
  flex-flow: row wrap;
`;

export const DetailsLabel = styled(BaseSecondaryText).attrs({size: 'S', weight: 500})`
  flex: 0 0 auto;
  margin-right: ${({theme}) => theme.spacing.s1};
  &::after {
    content: ':';
  }
`;

export const Price = styled(BasePrice)`
  ${mixins.f3}
  color: ${({theme}) => theme.branding.content.primary};
  font-weight: 400;
`;

export const TariffsContainer = styled.div`
  ${mixins.stack({size: '4'})}
  width: 100%;
`;
